import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { ActivityItemComponent } from './activities/activity-item/activity-item.component';
import { ActivitiesComponent } from './activities/activities.component';
import { PiplineComponent } from './pipleline-ang7'
//import { EnvironmentTypeModule } from './environments-ang7/environmentType';
//import { EnvironmentComponent } from './environments-ang7/environment/environment';
import { EnvironmentTypeModule } from './environments-ang7/environmentType.module';
import {processesHoverViewModule} from './processesHoverView-ang7/processesHoverView.module'
import {LegendModule} from './legend-ang7/legend.module'
import {EnvironmentTypeRotatorModule} from '../../projectWizard/assignSchemas-ang7/environmentTypeRotator/environmentTypeRotator.module'

@NgModule({
    declarations: [
        ActivityItemComponent,
        ActivitiesComponent,
        PiplineComponent
    ],
    imports: [SharedModule,processesHoverViewModule,EnvironmentTypeModule,EnvironmentTypeRotatorModule,LegendModule],
    exports: [ActivitiesComponent,PiplineComponent],
    entryComponents: [ActivitiesComponent,PiplineComponent]
})
export class PipelineModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/pipeline/pipeline.module.ts